import React, { useCallback, useMemo } from "react";
import { useSelector } from "react-redux";
import clsx from "clsx";
import { GLOBAL_MEETING_DATA, PublicVariables } from "../../../constants/PublicVariables";
import { CALL_BODY_SCREEN, ENABLED } from "../../../constants/Constants";
import { useFlags } from "launchdarkly-react-client-sdk";
import useLanguageChange from "../../../hooks/useLanguageChange";
import { handleStartStopVideo } from "./VideoUtils";
import { isSilentObserverAvailable } from "../../../shared/function";
import { handleStartStopVideoPlaySound } from "../Room/roomFunction";

const VideoButton = () => {
    const ldFlags = useFlags();
    const { isRemoteParticipantJoined, currentCallBodyScreen, isVideoButtonClickDisable } = useSelector((state) => state.commonReducer);
    const { startLocalVideo } = useSelector((state) => state.twilioEvents);

    /* custome hook for getting updated localized value object for entire project 
    This will give localize value object for selected language
    Also will give updated localized value object when language change*/
    const localisedValues = useLanguageChange();

    const videoButtonDisable = useMemo(() => {
        return isRemoteParticipantJoined && PublicVariables.featureFlag?.LIVEVIDEO === ENABLED;
    }, [isRemoteParticipantJoined]);

    const videoBtnAvailable = useCallback(() => {
        return !(GLOBAL_MEETING_DATA.isAgent && ldFlags.hideStartVideoButton === true) && PublicVariables.featureFlag?.LIVEVIDEO === ENABLED;
    }, [ldFlags]);

    const isButtonDisabled = useMemo(() => {
        return !videoButtonDisable || !videoBtnAvailable() || currentCallBodyScreen === CALL_BODY_SCREEN.NOTIFY_SCREEN || isVideoButtonClickDisable;
    }, [videoButtonDisable, currentCallBodyScreen, isVideoButtonClickDisable]);

    const clickOnStartStopVideoButton = () => {
        handleStartStopVideoPlaySound(!startLocalVideo); // handle heptic feedback
        handleStartStopVideo(true); // handle start/stop video
    };

    return (
        <>
            {!isSilentObserverAvailable() && (
                <div className='action-button' data-testid='video-button-div'>
                    <div className='action-button-in'>
                        <button
                            className={clsx("call-action-btn", !isButtonDisabled && startLocalVideo && "active")}
                            onClick={clickOnStartStopVideoButton}
                            disabled={isButtonDisabled}
                            data-testid='video-button'
                        >
                            <span className='action-button-icon'>
                                <span
                                    className={clsx(
                                        "for-icon",
                                        PublicVariables.featureFlag?.LIVEVIDEO === ENABLED && startLocalVideo === true
                                            ? "icon-video"
                                            : "icon-video-off"
                                    )}
                                ></span>
                            </span>
                            <span className='for-text'>
                                {PublicVariables.featureFlag?.LIVEVIDEO === ENABLED && !startLocalVideo
                                    ? localisedValues["start_video"]
                                    : localisedValues["stop_video"]}
                            </span>
                        </button>
                    </div>
                </div>
            )}
        </>
    );
};

export default VideoButton;
